export default __webpack_public_path__ + "static/media/PPI-patio-021.94abb31e.jpg";